/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import dayjs from 'dayjs';

import { useFormik } from 'formik';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { getNumberComma } from '../../utils/numberUtils';
import { Box} from '@mui/material';
import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';
import {
  listEtcProjects,
  resetEtcProjectFilters,
  setEtcProjectFilter,
} from '../../modules/projectModule/etcs';
import CmpStatusChip from '../../components/common/datagrid/CmpStatusChip';
//import { ProjectListBox } from '../../components/projectmng/ProjectListBox';
import {ShareSearchBox} from '../../components/common/search/ShareSearchBox';
import ShareSearchImpt from '../../components/common/search/ShareSearchImpt';
import StatusList from '../../components/common/info/StatusList';
import ProjectList from '../../components/projectmng/ProjectList';
import ChanceTotalSummary from '../../components/chancemng/ChanceTotalSummary';

const EtcProjectListContainer = ({ pageUrl }) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { projects, totals, defaultFilters, error, loading } = useSelector(
    ({ projectModule, loading }) => ({
      projects: projectModule.etcProjects.projects,
      totals: projectModule.etcProjects.totals,
      defaultFilters: projectModule.etcProjects.defaultFilters,
      error: projectModule.etcProjects.error,
      loading: loading['project/LIST_ETC_PROJECTS'],
    }),
  );
  const [tableData, setTableData] = useState([]);

  const currentMenu = window.location.pathname.split('/')[1] || '';

  const [isAllChecked, setIsAllChecked] = useState(() => {
    const savedPath = sessionStorage.getItem('checkedMenuPath');
    const savedValue = sessionStorage.getItem('isAllChecked');

    if (savedPath === currentMenu && savedValue) {
      return JSON.parse(savedValue);
    }
    
    return false;
  });

  useEffect(() => {
    sessionStorage.setItem('isAllChecked', JSON.stringify(isAllChecked));
    sessionStorage.setItem('checkedMenuPath', currentMenu);
  }, [isAllChecked, currentMenu]);

  
  const makeFilters = (filters) => {
    const startDate =
      filters.searchStrtDt !== null && filters.searchStrtDt !== ''
        ? dayjs(filters.searchStrtDt).format('YYYY-MM-DD')
        : '';
    const endDate =
      filters.searchEndDt !== null && filters.searchEndDt !== ''
        ? dayjs(filters.searchEndDt).format('YYYY-MM-DD')
        : '';

    let searchData = {
      cmpGrade: filters.searchGrade,
      prjImptsList: filters.searchPrjImpt,
      [filters.searchKeyword]: filters.searchWords,
      strtDt: startDate,
      endDt: endDate,
    };

    return searchData;
  };

  useEffect(() => {
    dispatch(listEtcProjects(makeFilters(defaultFilters)));
  }, [defaultFilters]);

  useEffect(() => {
    if (projects) {
      setTableData(projects);
    }
  }, [projects]);

  const handleFilters = (name, value) => {
    const newFilters = { ...defaultFilters, [name]: value };

    dispatch(setEtcProjectFilter(newFilters));
  };

  const handleRowClick = useCallback((param, event) => {
    navigate(`${pageUrl}/${param.id}/${param.row.cmpGrade}/1`);
  }, []);

  const handleAdd = () => {
    navigate(`${pageUrl}/add`);
  };

  const apiRef = useGridApiRef();

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
        disableExport: true,
      },
      {
        field: 'expDay',
        headerName: '매출월',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'clientCmpNm',
        headerName: '고객사명',
        minWidth: 180,
        flex: 1,
        type: 'string',
        align: 'left',
        headerAlign: 'center',
        editable: false,
      },
      {
        field: 'vendorCmpNm',
        headerName: '매출처명',
        minWidth: 180,
        flex: 1,
        type: 'string',
        align: 'left',
        headerAlign: 'center',
        editable: false,
      },
      {
        field: 'bookingDay',
        headerName: '계약일',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'cstNm',
        headerName: '사업명',
        minWidth: 280,
        flex: 1,
        description: '',
        align: 'left',
        headerAlign: 'center',
        editable: false,
      },
      {
        field: 'totalSales',
        headerName: '총매출액',
        minWidth: 120,
        flex: 1,
        description: '',
        align: 'right',
        headerAlign: 'center',
        editable: false,
        valueFormatter: (params) => getNumberComma(params.value),
        renderCell: (params) => getNumberComma(params.value),
      },
      {
        field: 'totalPurchase',
        headerName: '총매입액',
        minWidth: 120,
        flex: 1,
        description: '',
        align: 'right',
        headerAlign: 'center',
        editable: false,
        valueFormatter: (params) => getNumberComma(params.value),
        renderCell: (params) => getNumberComma(params.value),
      },
      {
        field: 'totalProfit',
        headerName: '매출이익',
        minWidth: 120,
        flex: 1,
        description: '',
        align: 'right',
        headerAlign: 'center',
        editable: false,
        valueFormatter: (params) => getNumberComma(params.value),
        renderCell: (params) => getNumberComma(params.value),
      },

      {
        field: 'cmpStatus',
        headerName: '상태',
        minWidth: 120,
        flex: 0.8,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: CmpStatusChip,
      },
      {
        field: 'crtDptNm',
        headerName: '부서',
        minWidth: 160,
        flex: 1,
        type: 'string',
        align: 'center',
        headerAlign: 'center',
        editable: false,
      },
      {
        field: 'crtNm',
        headerName: '영업담당자',
        minWidth: 120,
        flex: 0.5,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
        valueGetter: (params) => `${params.row.crtNm} ${params.row.crtGradeNm}`,
        renderCell: (params) => (
          <div>
            {params.row.crtNm} {params.row.crtGradeNm}
          </div>
        ),
      },
      {
        field: 'prjNo',
        headerName: '프로젝트 번호',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
        // renderCell: (params) => (
        //   params.row.prjNo
        // )
      },
    ],
    [],
  );

  const initialValues = {
    searchPrjImpt: defaultFilters.searchPrjImpt,
    searchKeyword: defaultFilters.searchKeyword,
    searchWords: defaultFilters.searchWords,
    searchStrtDt: defaultFilters.searchStrtDt,
    searchEndDt: defaultFilters.searchEndDt,
  };

  const validationSchema = yup.object({
    searchPrjImpt: yup.array().nullable(),
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
    searchStrtDt: yup.date().nullable().default(undefined),
    searchEndDt: yup
      .date()
      .min(yup.ref('searchStrtDt'), '검색 종료일을 확인하세요')
      .when('searchStrtDt', (searchStrtDt, schema) => {
        if (searchStrtDt) return schema.required('검색 종료일을 입력하세요');
      })
      .nullable()
      .default(undefined),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);

      setTimeout(() => {
        const searchData = {
          searchGrade: defaultFilters.searchGrade,
          searchPrjImpt: values.searchPrjImpt,
          searchKeyword: values.searchKeyword,
          searchWords: values.searchWords,
          searchStrtDt: values.searchStrtDt,
          searchEndDt: values.searchEndDt,
        };

        dispatch(setEtcProjectFilter(searchData));

        setSubmitting(false);
      }, 1000);
    },
  });
  const handleReset = () => {
    dispatch(resetEtcProjectFilters());
  };

  return (
    <>
      <BreadcrumbsContainer
        title="수주 관리/기타매출 관리/기타매출 리스트"
        icon="order"
      />
      {/* 1. [추가] 프로젝트 중요도 카드형 필드를 최상단에 배치 */}
      <Box sx={{ mb: 0.5 }}>
        <ShareSearchImpt 
          isLevel={false} // 프로젝트 관리 화면에 맞는 중요도 셀렉트박스/체크박스 모드 작동
          formik={formik} 
          totals={totals}  // 백엔드에서 받아온 등급별 통계 연동
        />
      </Box>

      {/* 3. [수정] 진행 상태 탭(StatusList)과 나머지 서치박스를 한 줄로 나란히 밀착 정렬 */}
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between', // 좌측엔 상태 탭바, 우측 끝엔 슬림 서치박스 배치
          gap: 2,                          // 두 컴포넌트 사이의 가로 여백
          width: '100%',
          my: 0.5                          // 상하 수직 간격을 최소화하여 타이트하게 정돈
        }}
      >
        <StatusList 
          filters={defaultFilters} 
          onFilters={handleFilters} 
          menu={'project'} // 프로젝트 전용 단독 진행상태 탭 모드로 작동
        />
        <ShareSearchBox
          isAllChecked={isAllChecked}
          setIsAllChecked={setIsAllChecked}
          formik={formik}
        />      
      </Box>


      {/* 2. [위치 이동] 전광판 요약 서머리를 필터 상단으로 전면 배치 
      <ChanceTotalSummary totals={totals} />
      */}
      {/* 4. 프로젝트 데이터 그리드 메인 목록 */}
      <ProjectList
        apiRef={apiRef}
        columns={columns}
        rows={tableData}
        error={error}
        loading={loading}
        handleRowClick={handleRowClick}
      />
    </>
  );
};

export default EtcProjectListContainer;
